var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as GiftFactory from "../../classes/definitions/gift/gift";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import GiftsList from '../../components/Gifts/GiftsList/GiftsList';
import AppRoutes from '../../config/appRoutes';
import GiftsReduxProps from "./GiftsReduxProps";
var Gifts = /** @class */ (function (_super) {
    __extends(Gifts, _super);
    function Gifts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllSamples = function () {
            _this.api.getGifts()
                .then(function (response) {
                var samples = GiftFactory.createGifts(response.data);
                var meta = _.get(response, 'data.meta', null);
                _this.setState({ data: samples, meta: meta });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с порадаръци', _this.props.history);
            });
        };
        _this.toNewSample = function () {
            _this.props.history.push(AppRoutes.gift.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Gifts.prototype.componentDidMount = function () {
        this.getAllSamples();
        console.log('process.env.REACT_APP_PUBLIC_DOMAIN', process.env.REACT_APP_PUBLIC_DOMAIN);
    };
    Gifts.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u041F\u043E\u0434\u0430\u0440\u044A\u0446\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewSample, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u043F\u043E\u0434\u0430\u0440\u044A\u043A")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(GiftsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return Gifts;
}(React.Component));
export default connect(null, GiftsReduxProps.mapDispatchToProps)(Gifts);



//////////////////
// WEBPACK FOOTER
// ./src/views/Gifts/Gifts.tsx
// module id = 361
// module chunks = 0